import { render, staticRenderFns } from "./CompContent.vue?vue&type=template&id=19301dce&"
import script from "./CompContent.vue?vue&type=script&lang=js&"
export * from "./CompContent.vue?vue&type=script&lang=js&"
import style0 from "./CompContent.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports